// Recharge Storefront Experiences owns the staged React cart drawer. Keep
// this delegated fallback in the product asset that is known to execute on
// Resin V4, and scope it to Recharge's exact dialog/form/button combination.
if (!window.__ecRechargeDrawerCheckoutGuard) {
window.__ecRechargeDrawerCheckoutGuard = true;
(function () {
    function routeRechargeDrawerToCheckout(form, button, event) {
        if (!form || !button) return false;
        var actionPath = new URL(form.action || '/cart', window.location.origin).pathname.replace(/\/+$/, '');
        var dialog = form.closest('[role="dialog"]');
        var rechargeRoot = document.getElementById('recharge-storefront-experiences');
        var isCheckoutButton = button.matches('button[data-slot="button"]')
            && button.type === 'submit'
            && /^checkout$/i.test((button.textContent || '').trim());
        if (!actionPath.endsWith('/cart') || !rechargeRoot || !dialog || !isCheckoutButton) return false;
        if (window.__ecRechargeDrawerCheckoutRouting) return true;
        window.__ecRechargeDrawerCheckoutRouting = true;
        event.preventDefault();
        event.stopImmediatePropagation();
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';
        window.location.assign(root + 'checkout');
        return true;
    }

    document.addEventListener('click', function (event) {
        var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
        var button = path.find(function (candidate) {
            return candidate && candidate.matches && candidate.matches('button[data-slot="button"]');
        }) || null;
        if (button && button.form) routeRechargeDrawerToCheckout(button.form, button, event);
    }, true);

    document.addEventListener('submit', function (event) {
        var form = event.target;
        var button = event.submitter || (form && form.querySelectorAll
            ? Array.from(form.querySelectorAll('button[data-slot="button"]')).find(function (candidate) {
                return candidate.type === 'submit' && /^checkout$/i.test((candidate.textContent || '').trim());
              })
            : null);
        routeRechargeDrawerToCheckout(form, button, event);
    }, true);
})();
}

if (!window.__ecHandleVariantListenerRegistered) {
window.__ecHandleVariantListenerRegistered = true;
document.addEventListener('alpine:init', () => {
    Alpine.data('handleVariant', (pProduct = null, optionsByName = null, selectedOrFirstAvailable = null) => ({
        bundle: {},
        product: pProduct,
        options_by_name: optionsByName,
        options: pProduct?.options,
        variants: pProduct?.variants,
        selected_or_first_available_variant: selectedOrFirstAvailable,
        variantImage: selectedOrFirstAvailable?.featured_image?.src,
        selected_product_id: selectedOrFirstAvailable?.id,
        _price: selectedOrFirstAvailable?.price ?? 0,
        quantity: 1,
        addToCartButton: true,
        isAddingToCart: false,
        firstOptionHasAvailableChildren: {},
        selectorType: 'radio',
        formSelector: "#product_form_" + pProduct.id,
        isMainProduct: false,

        // Use init for debugging
        init() {
            const productId = document.querySelector('#shopify-section-product_hero [li-element="product-variant-container"][data-productid]')?.getAttribute('data-productid');
            this.isMainProduct = parseInt(productId) === parseInt(pProduct.id);
            const localForm = this.$root?.querySelector?.('form.ec-rv7__product-form, form[action*="/cart/add"]');
            if (localForm?.id) {
                const escapedFormId = window.CSS?.escape
                    ? window.CSS.escape(localForm.id)
                    : localForm.id.replace(/[^a-zA-Z0-9_-]/g, '');
                this.formSelector = `#${escapedFormId}`;
            }
            //     console.log('Shopify', Shopify)
            //     console.log('product', this.product)
            //     console.log('options_by_name', this.options_by_name)
            //     console.log('selected_or_first_available_variant', this.selected_or_first_available_variant)
        },

        qs(selector) {
            const root = this.$root?.querySelector ? this.$root : document;
            return root.querySelector(selector)
        },

        qsa(selector) {
            const root = this.$root?.querySelectorAll ? this.$root : document;
            return root.querySelectorAll(selector)
        },

        set price(value) {
            if (isNaN(value)) {
                throw new Error('price have to be a number');
            }
            this._price = value;
        },

        get price() {
            const price = new Intl.NumberFormat(Shopify.locale + '-' + Shopify.country, {
                style: 'currency',
                currency: Shopify.currency.active,
            });
            return price.format(this._price / 100 ?? 0);
        },

        observeVariants() {
            if(this.isMainProduct) {
                // todo: maybe via $dispatch or helper?!
                let $this = this;
                window.onpopstate = function(event) {

                    const urlParams = new URLSearchParams(window.location.search);
                    const variantId = urlParams.get('variant');
                    const observer = new MutationObserver(mutationCallback);
                    //fixme: maybe in helper?!
                    function mutationCallback(mutations) {
                        mutations.forEach(function(mutation) {
                            if (mutation.type === "attributes" && (mutation.attributeName === "checked" || mutation.attributeName === "selected")) {
                                // fixme: kann/muss theoretisch weg, da über :class gelöst werden muss
                                mutation.target.previousElementSibling.classList.remove('w--redirected-checked', 'w--redirected-focus')
                                if(mutation?.target?.checked || mutation?.target?.selected) {
                                    mutation.target.previousElementSibling.classList.add('w--redirected-checked', 'w--redirected-focus')
                                    $this.setVariant(false)
                                }
                            }
                        })
                        observer.disconnect()
                    }

                    selectedOrFirstAvailable = $this?.variants.filter(variant => parseInt(variant.id) === parseInt(variantId))[0]

                    $this.selected_or_first_available_variant = selectedOrFirstAvailable;

                    $this.options.forEach(function (option) {
                        let selector = $this.formSelector + " [data-productVariantsLoop] input[name='" + option + "']"
                        if($this.selectorType === 'select') {
                            selector = $this.formSelector + " [data-productVariantsLoop] select[name='" + option + "'] option"
                        }
                        $this.qsa(selector).values().forEach(function(element) {
                            observer.observe(element, {
                                attributes: true
                            });
                        })
                    })
                }
            }
        },

        updateVariantStatuses() {
            const selectedOptionOneVariants = this.variants.filter((variant) => {
                    let querySelector = this.formSelector + ' [data-productVariantsLoop] input[type="radio"]:checked'
                    if (this.selectorType === 'select') {
                        querySelector = this.formSelector + ' [data-productVariantsLoop] select'
                    }
                    return this.qs(querySelector)?.value === variant.option1
                }
            );

            const inputWrappers = [...this.qsa(this.formSelector + ' [data-ProductVariantsLoop]')];

            inputWrappers.forEach((option, index) => {
                if (index === 0) return;
                let optionInputs = [...option.querySelectorAll('input[type="radio"]')];
                if (this.selectorType === 'select') {
                    optionInputs = [...option.querySelectorAll('option')];
                }
                const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
                const availableOptionInputsValue = selectedOptionOneVariants
                    .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
                    .map((variantOption) => variantOption[`option${index + 1}`]);
                this.setInputAvailability(optionInputs, availableOptionInputsValue);

            });
        },

        setInputAvailability(listOfOptions, listOfAvailableOptions) {
            listOfOptions.forEach((input) => {
                if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                    input.classList.remove('disabled');
                    input.removeAttribute('disabled');

                } else {
                    input.classList.add('disabled');
                    input.setAttribute('disabled', '');
                }
            });

        },

        activateVariants() {
            this.observeVariants();

            this.selectorType = this.qs('[data-selectorType]')?.dataset?.selectortype ?? this.selectorType

            this.variants.map((variant) => {
                if (this.firstOptionHasAvailableChildren[variant?.option1] === undefined) {
                    this.firstOptionHasAvailableChildren[variant?.option1] = 0;
                }
                this.firstOptionHasAvailableChildren[variant?.option1] += variant?.available;
            });

            const option1 = this.getVariantElement(this.options?.[0]);
            const option2 = this.getVariantElement(this.options?.[1]);
            const option3 = this.getVariantElement(this.options?.[2]);
            if (option1) {
                this.activateVariant(option1)
            }
            if (option2) {
                this.activateVariant(option2)
            }
            if (option3) {
                this.activateVariant(option3)
            }
            this.updateVariantStatuses()

            // @todo: Replace with CSS
            const css = ' [data-ProductVariantsLoop] input[type=radio]:disabled+span, ' +
                ' [data-ProductVariantsLoop] input[type=radio].disabled+span{ ' +
                ' text-decoration: line-through; ' +
                ' opacity: .5; ' +
                ' } ' +
                ' .button.max-width-full.w-button:disabled, ' +
                ' .button.max-width-full.w-button[disabled] { ' +
                '  cursor: not-allowed; ' +
                ' }';
            const style = document.createElement("style")
            const head = document.getElementsByTagName('head')[0]
            head.appendChild(style)
            style.appendChild(document.createTextNode(css));
        },

        activateVariant(element) {
            element.previousElementSibling.classList.add('w--redirected-checked')
        },

        /**
         * Holt aus der übergebenen Optionsgruppe den Wert des selektierten Redio-Buttons
         */
        checkedVariantValue(optionName) {
            return this.getVariantElement(optionName)?.value;
        },

        /**
         * Holt aus der übergebenen Optionsgruppe das selektierte Element
         */
        getVariantElement(optionName) {
            let selector = this.formSelector + " [data-productVariantsLoop] input[name='" + optionName + "']:checked"
            if (this.selectorType === 'select') {
                selector = this.formSelector + " [data-productVariantsLoop] select[name='" + optionName + "'] option:checked"
                if (this.qs(selector)?.disabled) {
                    selector = this.formSelector + " [data-productVariantsLoop] select[name='" + optionName + "'] option:not([disabled])"
                }
            }
            return this.qs(selector) ? this.qs(selector) : '';
        },

        filterVariants() {
            const option1 = this.checkedVariantValue(this.options?.[0]);
            const option2 = this.checkedVariantValue(this.options?.[1]);
            const option3 = this.checkedVariantValue(this.options?.[2]);

            let selectedOptions = [
                option1,
                option2,
                option3,
            ];
            selectedOptions = (selectedOptions.filter(i => i)).join('-')

            let possibleProducts = []
            for (const variant of this.variants) {
                let variantString = [
                    option1 ? variant?.option1 : undefined,
                    option2 ? variant?.option2 : undefined,
                    option3 ? variant?.option3 : undefined,
                ];
                variantString = (variantString.filter(i => i)).join('-')

                if (selectedOptions === variantString) {
                    possibleProducts.push(variant)
                }
            }

            return possibleProducts;
        },

        setUrlParam() {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('variant', this.selected_product_id);

            window.history.pushState({ ...window.history.state}, '', '?' + urlParams.toString());
        },

        setVariant(pushState = true) {
            this.updateVariantStatuses()
            const matchedProducts = this.filterVariants()

            if (matchedProducts.length !== 1) {
                console.warn('Keine eindeutige Variante', matchedProducts)
                //this.updateVariantStatuses()
                this.addToCartButton = false
                return
            }


            this.addToCartButton = true

            const matchedProduct = matchedProducts[0];
            console.log('matchedProducts', matchedProduct)
            this.selected_product_id = matchedProduct.id
            this.variantImage = matchedProduct?.featured_image?.src
            this.price = matchedProduct?.price;
            this.selected_or_first_available_variant = matchedProduct;
            // nur für die Detailseiten
            if(pushState && this.isMainProduct) {
                this.setUrlParam()
            }
        },

        getAddToCartBody(products) {
            return JSON.stringify({
                'items': products.map(product => ({
                    id: product.id,
                    quantity: product.quantity ?? 1,
                }))
            });
        },

        callAddToCartApi(body) {
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: body
            })
        },

        /**
         * Add all products to cart.
         */
        async addToCartWithBundle() {
            console.log('addToCartWithBundle() called!');

            // Map all bundle products
            const products = Object.entries(this.bundle).map(([key, value]) => ({
                id: value,
                quantity: 1
            }))

            // Add selected product
            products.push({
                id: this.selected_product_id ?? this.selected_or_first_available_variant?.id,
                quantity: this.quantity ?? 1,
            })

            // Create body with all products
            let body = this.getAddToCartBody(products);

            // Single API call for all products
            try {
                let response = await this.callAddToCartApi(body);
                let data = await response.json();
                console.log('Items added (addToCartWithBundle()):', data.items);
                this.products = data.items;

                // Trigger dropdown click to open minicart
                let elements = document.querySelectorAll('[li-element="mini-cart-trigger"]');
                elements.forEach(element => {
                    let closestDropdown = element.closest('.w-dropdown-toggle');
                    if (closestDropdown) {
                        LiquifyHelper.triggerClick(closestDropdown);
                    }
                });

                console.log('All items added!');
                this.$dispatch('toggleminicart');
                this.$dispatch('showcartmessage', {
                    status: data.status,
                    message: data.message,
                    description: data.description
                });
            } catch (error) {
                console.error('Error in add to cart with bundle:', error);
                this.$dispatch('showcartmessage', {
                    status: error.status,
                    message: error.message,
                    description: error.description
                });
            }
        },

        /**
         * Add a single product to cart.
         */
        async addToCart(productId = undefined, quantity = undefined) {
            if (this.isAddingToCart) return;

            const fail = (message, description, status = 422) => {
                this.$dispatch('showcartmessage', { status, message, description });
                return false;
            };
            const selectedVariant = this.selected_or_first_available_variant;
            const variantId = productId ?? this.selected_product_id ?? selectedVariant?.id;
            const requestedQuantity = Number(quantity ?? this.quantity ?? 1);
            const productVariants = Array.isArray(this.product?.variants) ? this.product.variants : [];
            const variantBelongsToProduct = productVariants.some((variant) => String(variant.id) === String(variantId));

            if (!selectedVariant?.available) {
                return fail('Unavailable', 'This product option is not available.');
            }
            if (!this.product?.id || !variantId || !Number.isInteger(requestedQuantity) || requestedQuantity < 1) {
                return fail('Choose a valid option', 'Please review the product option and quantity.');
            }
            if (!variantBelongsToProduct || String(selectedVariant.id) !== String(variantId)) {
                return fail('Product selection changed', 'Please choose the product option again before adding it to cart.');
            }

            const componentRoot = this.$root?.closest?.('[data-ec-rv7-section]') || this.$root;
            if (!componentRoot?.querySelectorAll) {
                return fail('Purchase options unavailable', 'Please refresh the page and try again.');
            }

            let planData = null;
            const planDataElement = componentRoot.querySelector('[data-ec-rv7-plan-data]');
            if (planDataElement) {
                try {
                    planData = JSON.parse(planDataElement.textContent || '{}');
                } catch (_) {
                    return fail('Purchase options unavailable', 'The current subscription terms could not be read. Please refresh and try again.');
                }
            }

            let purchaseMode = null;
            let planId = null;
            let widgetPlanIds = [];
            const rechargeWidgets = [...componentRoot.querySelectorAll('recharge-subscription-widget')];
            if (rechargeWidgets.length > 1) {
                return fail('Purchase options unavailable', 'Multiple purchase controls were detected. Please refresh and try again.');
            }

            if (rechargeWidgets.length === 1) {
                const rechargeWidget = rechargeWidgets[0];
                const widgetProductId = rechargeWidget.getAttribute('product-id');
                if (!widgetProductId || String(widgetProductId) !== String(this.product.id)) {
                    return fail('Purchase options do not match this product', 'Please refresh the page and select your purchase option again.');
                }
                if (!rechargeWidget.shadowRoot) {
                    return fail('Purchase options are still loading', 'Please wait a moment and try again.');
                }

                const checkedPurchaseModes = new Set();
                const checkedPlanIds = new Set();
                const inspectRechargeRoot = (root) => {
                    root.querySelectorAll('input[type="radio"]').forEach((input) => {
                        if (input.name === 'rc_plan' && input.value) widgetPlanIds.push(String(input.value));
                        if (!input.checked) return;
                        if (input.name === 'purchaseOption' && input.value) checkedPurchaseModes.add(String(input.value));
                        if (input.name === 'rc_plan' && input.value) checkedPlanIds.add(String(input.value));
                    });
                    root.querySelectorAll('*').forEach((element) => {
                        if (element.shadowRoot) inspectRechargeRoot(element.shadowRoot);
                    });
                };
                inspectRechargeRoot(rechargeWidget.shadowRoot);

                if (checkedPurchaseModes.size !== 1) {
                    return fail('Choose how you buy', 'Select subscription or one-time purchase before adding to cart.');
                }
                purchaseMode = [...checkedPurchaseModes][0];

                if (purchaseMode === 'onetime' || purchaseMode === 'one_time') {
                    purchaseMode = 'one_time';
                    planId = null;
                } else if (purchaseMode === 'subscription') {
                    if (checkedPlanIds.size !== 1) {
                        return fail('Choose a delivery schedule', 'Select your delivery schedule again before adding to cart.');
                    }
                    planId = [...checkedPlanIds][0];
                } else {
                    return fail('Choose how you buy', 'Select subscription or one-time purchase before adding to cart.');
                }
            } else {
                const legacyPlanInput = componentRoot.querySelector('[data-sls-selling_plan]');
                if (legacyPlanInput) {
                    planId = legacyPlanInput.value || null;
                    purchaseMode = planId ? 'subscription' : 'one_time';
                } else if (Array.isArray(planData?.plans) && planData.plans.length) {
                    return fail('Purchase options are still loading', 'Please wait for the official purchase options and try again.');
                } else {
                    purchaseMode = 'one_time';
                }
            }

            const allowedPlanIds = Array.isArray(planData?.plans)
                ? planData.plans.map((plan) => String(plan.id)).filter(Boolean)
                : [];
            widgetPlanIds = [...new Set(widgetPlanIds)];
            if (purchaseMode === 'subscription') {
                const selectedPlanId = String(planId);
                if (allowedPlanIds.length && !allowedPlanIds.includes(selectedPlanId)) {
                    return fail('Subscription option mismatch', 'The selected delivery schedule is not available for this product option.');
                }
                if (widgetPlanIds.length && !widgetPlanIds.includes(selectedPlanId)) {
                    return fail('Subscription option mismatch', 'Please select an available delivery schedule and try again.');
                }
            }

            const item = { id: variantId, quantity: requestedQuantity };
            if (purchaseMode === 'subscription') item.selling_plan = planId;
            this.isAddingToCart = true;

            try {
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [item] })
                });
                const data = await response.json().catch(() => ({}));
                if (!response.ok) {
                    const requestError = new Error(data.description || data.message || 'Shopify could not add this item.');
                    requestError.status = response.status || 422;
                    requestError.description = data.description || 'Please review your purchase option and try again.';
                    throw requestError;
                }
                if (!Array.isArray(data.items) || !data.items.length) {
                    const responseError = new Error('Shopify returned no cart line.');
                    responseError.status = 422;
                    throw responseError;
                }

                const addedLine = data.items.find((line) => String(line.variant_id ?? line.id) === String(variantId));
                const returnedPlanId = addedLine?.selling_plan_allocation?.selling_plan?.id;
                if (!addedLine
                    || (purchaseMode === 'subscription' && String(returnedPlanId) !== String(planId))
                    || (purchaseMode === 'one_time' && returnedPlanId)) {
                    const handoffError = new Error('The cart response did not match your selected purchase option.');
                    handoffError.status = 409;
                    handoffError.description = 'Please review the cart before continuing to checkout.';
                    throw handoffError;
                }

                this.products = data.items;
                document.querySelectorAll('[li-element="mini-cart-trigger"]').forEach((element) => {
                    const closestDropdown = element.closest('.w-dropdown-toggle');
                    if (closestDropdown) LiquifyHelper.triggerClick(closestDropdown);
                });
                this.$dispatch('toggleminicart');
                this.$dispatch('showcartmessage', {
                    status: data.status,
                    message: data.message,
                    description: data.description
                });
            } catch (error) {
                console.error('addToCart error:', error);
                this.$dispatch('showcartmessage', {
                    status: error.status || 422,
                    message: error.message || 'Unable to add this item.',
                    description: error.description || 'Please try again.'
                });
            } finally {
                this.isAddingToCart = false;
            }
        },

        /**
         * Format monetary values.
         */
        moneyFormat(value, minor = true) {
            return LiquifyHelper.moneyFormat(value, minor)
        },
    }));
})
}
